/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Promotion_DescriptionInputs */

const en_directory_promotion_description = /** @type {(inputs: Directory_Promotion_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sponsor is a paid directory plan. After you activate it, submit your tool through the existing review flow to receive labeled sponsor placement and social promotion.`)
};

const zh_directory_promotion_description = /** @type {(inputs: Directory_Promotion_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sponsor 是目录中的付费套餐。激活后，你可以通过现有审核流程提交产品，获得明确标注的赞助展示和社交媒体推广。`)
};

/**
* | output |
* | --- |
* | "Sponsor is a paid directory plan. After you activate it, submit your tool through the existing review flow to receive labeled sponsor placement and social pr..." |
*
* @param {Directory_Promotion_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_promotion_description = /** @type {((inputs?: Directory_Promotion_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Promotion_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_promotion_description(inputs)
	return zh_directory_promotion_description(inputs)
});
export { directory_promotion_description as "directory.promotion.description" }